module.exports = __webpack_public_path__ + "img/78.6b40a056.svg";